<template>
  <div class="main-content">
    <b-card no-body>
      <!-- Table Start -->

      <b-row class="m-3">
        <b-col md="4" class="my-1">
          <b-form-group label-cols-sm="2" class="mb-0">
            <b-input-group>
              <b-form-input
                v-model="filter"
                :placeholder="$t('type_search')"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">{{
                  $t("filter")
                }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="3" class="my-1">
          <b-form-group label-cols-sm="4" :label="$t('show')" class="mb-0">
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col v-if="isAdd" md="2" class="my-1">
          <b-row>
            <b-col md="6">
              {{ $t("Crear") }}
              <strong>{{ title }}</strong>
            </b-col>
            <b-col md="6">
              <b-icon
                @click="addNewModal()"
                class="h2 rounded bg-primary"
                icon="plus"
                variant="light"
              ></b-icon>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-if="backendFilters.length > 0 || frontendFilters.length > 0"
          md="2"
        >
          <b-form-checkbox
            v-model="isfilter"
            v-b-toggle.collapse-3
            switch
            size="md"
            >{{ $t("hide_show") }}</b-form-checkbox
          >
        </b-col>
      </b-row>

      <div>
        <b-collapse v-model="isfilter">
          <hr v-if="backendFilters.length > 0" />
          <DynamicComponent
            v-if="backendFilters.length > 0"
            v-bind:isDynamic="true"
            @filter-change="onFilterChange"
            v-bind:fields="backendFilters"
          ></DynamicComponent>
          <hr v-if="frontendFilters.length > 0" />
          <DynamicComponent
            v-if="frontendFilters.length > 0"
            v-bind:isDynamic="false"
            @filter-change="onFilterChange"
            v-bind:fields="frontendFilters"
          ></DynamicComponent>
        </b-collapse>
      </div>

      <br />

      <!-- Main table element -->
      <b-table
        responsive
        striped
        foot-clone
        :empty-text="$t('empty_text')"
        :busy.sync="isBusy"
        :show-empty="!isBusy"
        :items="items"
        :fields="render"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        small
        no-footer-sorting
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ $t("loading") }}</strong>
        </div>
        <template v-slot:cell(action)="row">
          <b-row cols="1" cols-sm="1" cols-md="5" cols-lg="5">
            <b-col v-for="(action, index) in actions" :key="index">
              <b-icon
                :id="`button-${row.index}-${index}`"
             
                @click="handDynamic(row, action)"
                class="mb-0 h5"
                :icon="action.icon"
                :variant="action.variant"
              ></b-icon>
              <b-tooltip :target="`button-${row.index}-${index}`" :title="action.popupDecription" triggers="hover">
 
</b-tooltip>

              <!-- <b-icon
                v-if="isEdit"
                @click="editRow(row, false)"
                class="mb-0 h5"
                icon="pencil"
                variant="primary"
              ></b-icon>
            </b-col>
            <b-col>
              <b-icon
                v-if="isShow"
                @click="editRow(row, true)"
                class="mb-0 h5"
                icon="eye-fill"
                variant="primary"
              ></b-icon>
            </b-col>
            <b-col>
              <b-icon
                v-if="isDelete"
                @click="handleDelete(row)"
                class="mb-0 h5"
                icon="x-circle-fill"
                variant="danger"
              ></b-icon> -->
            </b-col>
          </b-row>
        </template>

        <template
          v-slot:[gomycell(footer.key)]="scope"
          v-for="(footer, index) in footerData"
        >
          <h6 v-bind:key="index" class="font-weight-bold text-primary">
            {{ footer.value }}
          </h6>
        </template>
        <template v-slot:foot()>
          <p></p>
        </template>
        <template
          v-slot:[gomycellCol(decimal.key)]="data"
          v-for="(decimal, index) in decimalData"
        >
          <div v-bind:key="index">{{ getFormatedDecimal(data) }}</div>
        </template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="edit-modal"
      @cancel="resetModal"
      @ok="handleOk"
      v-show="isShowDialog"
      v-model="isShowDialog"
      size="lg"
      :title="title"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-form ref="form" @submit.stop.prevent>
        <b-container fluid>
          <div v-for="(field, index) in fieldsToEdit" :key="index">
            <div class="mt-1" v-if="isJsonObjectExist(field, 'groupName')">
              <hr v-if="index != 0" />
              <h5>
                {{ field.groupName }}
              </h5>
              <hr />
            </div>
            <b-row class="my-1">
              <b-col sm="3">
                <label :for="`type-${field.type}`">{{ field.label }}:</label>
              </b-col>
              <b-col sm="9">
                <b-form-select
                  v-model="fieldsData[field.key]"
                  v-if="field.field == 'list'"
                  :options="field.list"
                  size="sm"
                  :disabled="isViewCase == true ? true : field.disabled"
                  class="mt-3"
                ></b-form-select>

                <div
                  v-if="
                    field.field == 'input' && !isJsonObjectExist(field, 'lines')
                  "
                >
                  <b-form-input
                    :disabled="isViewCase == true ? true : field.disabled"
                    :no-wheel="true"
                    :state="nameState(field.pattern, fieldsData[field.key])"
                    v-model="fieldsData[field.key]"
                    v-if="field.field == 'input'"
                    :placeholder="field.label"
                    :type="field.type"
                    :required="field.required"
                  ></b-form-input>

                  <b-form-invalid-feedback
                    :disabled="isViewCase == true ? true : field.disabled"
                    v-if="field.field == 'input'"
                    :state="nameState(field.pattern, fieldsData[field.key])"
                    >{{ field.feedback }}</b-form-invalid-feedback
                  >
                </div>
                <div
                  v-else-if="
                    field.field == 'input' && isJsonObjectExist(field, 'lines')
                  "
                >
                  <b-form-textarea
                    :disabled="isViewCase == true ? true : field.disabled"
                    id="textarea-auto-height"
                    v-model="fieldsData[field.key]"
                    v-if="field.field == 'input'"
                    :placeholder="field.label"
                    :required="field.required"
                    :rows="field.lines"
                    :max-rows="field.lines"
                  ></b-form-textarea>
                </div>

                <b-form-checkbox
                  :disabled="isViewCase == true ? true : field.disabled"
                  v-model="fieldsData[field.key]"
                  :required="field.required"
                  :value="field.trueValue"
                  v-if="field.field == 'checkbox'"
                ></b-form-checkbox>

                <b-form-radio-group
                  :disabled="isViewCase == true ? true : field.disabled"
                
                  :required="field.required"
                  v-model="fieldsData[field.key]"
                  :options="field.options"
                  v-if="field.field == 'radioGroup'"
                >
                </b-form-radio-group>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </b-form>
    </b-modal>
    <b-modal
      v-model="isInfoDialog"
      ref="simple_show_info"
      id="simple_show_info"
      :title="$t('info')"
      @ok="handleSubmit"
    >
      <p>{{ message }}</p>
    </b-modal>
  </div>
</template>
<script>
import ApiManger from "../../services/homeapi";
import Auth from "../../services/auth";
import DynamicComponent from "../../components/filter/DynamicComponent";

export default {
  components: {
    DynamicComponent,
  },

  data() {
    return {
      orignalData: {},

      isBusy: true,
      items: [],
      message: "",
      /**
       * *All item is used to keep the the all item for maintaing filters
       */
      allItems: [],
      /**
       * *it contains the all filterd values
       */

      footerData: [],
      decimalData: [],

      filterData: [],

      pdfdata: [],

      render: [],
      isLoading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      userPermission: "",

      isShowDialog: false,
      isInfoDialog: false,

      isEdit: false,
      isAdd: false,
      isShow: false,
      isDelete: false,
      isViewCase: false,

      fieldsToEdit: [],
      fieldsData: {},

      //For filters
      fields: [],
      backendFilters: [],
      frontendFilters: [],

      //? is is used to create table action button
      actions: [],

      backendFiltersBackUp: [],
      frontendFiltersBackUp: [],

      columnsToEdit: {},
      columnsToAdd: {},
      columnsToAddDefaultValue: {},

      realFieldsData: {},

      title: "",
      formData: {},
      endPoint: "",

      addNew: false,
      isDeleteItem: false,

      isfilter: true,
    };
  },

  props: {
    menu: {
      type: Object,
      default: null,
    },
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.render
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getFullPath() {
      return this.$route.path;
    },
  },

  watch: {
    getFullPath() {
      this.backendFilters = [];
      this.frontendFilters = [];
      this.actions = [];

      // console.log("Test",JSON.stringify(this.$route.params));

      Auth.setEndPoint(this.$route.params.menu);
      this.userPermission = this.$route.params.menu.permissions;
      this.title = this.$route.params.menu.title;
      this.endpoint = this.$route.params.menu.endpoint;
      this.isShowDialog = false;

      this.isAdd = false;
      this.isEdit = false;
      this.isShow = false;
      this.isDelete = false;

      this.isViewCase = false;

      this.columnsToEdit = {};
      this.columnsToAdd = {};
      this.columnsToDisplay;
      this.getUserData(this.endpoint, {});
    },
  },

  mounted() {
    this.backendFilters = [];
    this.frontendFilters = [];
    this.userPermission = Auth.getEndPoint().permissions;
    this.title = Auth.getEndPoint().title;
    this.endpoint = Auth.getEndPoint().endpoint;
    this.getUserData(Auth.getEndPoint().endpoint, {});
    //(  this.userPermission );
  },

  methods: {
    isJsonObjectExist(obj, keytofind) {
      //console.log(JSON.stringify(obj));
      // console.log(keytofind);
      return Object.prototype.hasOwnProperty.call(obj, keytofind);
      //return Object.prototype.hasOwnProperty.call(obj, key);
    },
    nameState(regex, data) {
      return regex == "" ? true : new RegExp(regex).test(data);
    },
    getTableData() {
      // console.log(JSON.stringify( columnNames));
      this.render = this.columnNames.filter((item) => {
        {
          return item;
        }
      });

      //("getTableData");

     

      this.renderDisplay();
    },

    renderDisplay() {
      var permissions = this.userPermission.split("|");
      for (var permission of permissions) {
        //  console.log(permission);
        switch (permission) {
          case "write":
            this.isEdit = true;
            break;
          case "add":
            this.isAdd = true;
            break;
          case "show":
            this.isShow = true;
            break;
          case "delete":
            this.isDelete = true;
            break;

          default:
            break;
        }

          if(this.actions.length>0){
               this.render.push({
                key: "action",
                label: "Action",
              });
          }

        // console.log(this.isEdit);
      }
    },

    renderDisplayAction() {
      var permissions = this.userPermission.split("|");
      for (var permission of permissions) {
        //  console.log(permission);
        switch (permission) {
          case "add":
            this.isAdd = true;
            break;
        }

        // console.log(this.isEdit);
      }

      if (this.isShow == true || this.isEdit == true || this.isDelete == true) {
        this.render.push({
          key: "action",
          label: "Action",
        });
      }
    },

    getUserData(endpoint, param) {
      this.columnNames = [];
      this.footerData = [];
      this.decimalData = [];
      this.items = [];
      this.allItems = [];
      this.isBusy = true;
      this.isLoading = true;

      ApiManger.getHome(endpoint, "get", param).then((res) => {
        this.isLoading = false;
        this.isBusy = false;
        if (res.errorCode == 0) {
          this.columnNames = res.data.columnsToDisplay;

          this.updateFooterData(this.columnNames);
          this.updateDecimalData(this.columnNames);

          if (Object.getOwnPropertyDescriptor(res.data, "frontendFilters")) {
            var newArray = JSON.parse(JSON.stringify(res.data.frontendFilters));
            this.frontendFiltersBackUp = res.data.frontendFilters;
            this.frontendFilters = newArray.slice();
          }

          if (Object.getOwnPropertyDescriptor(res.data, "backendFilters")) {
            this.backendFilters = JSON.parse(
              JSON.stringify(res.data.backendFilters)
            );
            this.backendFiltersBackUp = JSON.parse(
              JSON.stringify(res.data.backendFilters)
            );
          }

          if (Object.getOwnPropertyDescriptor(res.data, "actions")) {
            //var newArray = JSON.parse(JSON.stringify(res.data.actions));
          
            
            this.actions = res.data.actions;
            //  this.frontendFilters = newArray.slice();
          }

          this.columnsToEdit = res.data.columnsToEdit;

          if (Object.getOwnPropertyDescriptor(res.data, "columnsToAdd")) {
            this.columnsToAdd = res.data.columnsToAdd.fieldsToAdd;

            this.columnsToAddDefaultValue = JSON.parse(
              JSON.stringify(res.data.columnsToAdd.defaulFieldsValue)
            );
            this.fieldsData = JSON.parse(
              JSON.stringify(res.data.columnsToAdd.defaulFieldsValue)
            );
          }

          this.getTableData();

          this.fromatWebAccessData(res.data.data);
          this.pdfdata = res.data.data;
          this.isBusy = false;
          this.totalRows = res.data.data.length;
        }
      });
    },

    fromatWebAccessData(data) {
      this.allItems = data;
      this.items = JSON.parse(JSON.stringify(data));
      this.updateTotal(this.footerData, this.items);
    },

    gomycell(key) {
      return `foot(${key})`;
    },

    gomycellCol(key) {
      return `cell(${key})`;
    },

    updateFooterData(jsonObj) {
      var vm = this;
      this.footerData = jsonObj.filter(function (obj) {
        obj.value = 0;
        return vm.isJsonObjectExist(obj, "isTotal");
      });
      //  console.log(this.footerData);
    },

    updateDecimalData(jsonObj) {
      var vm = this;
      this.decimalData = jsonObj.filter(function (obj) {
        obj.value = 0;
        return vm.isJsonObjectExist(obj, "decimals");
      });
      //console.log(JSON.stringify(this.decimalData));
    },

    updateTotal(footerData, tableData) {
      footerData.reduce((total, footItem) => {
        // if the value is an array then recursively call reduce
        // if the value is not an array then just concat our value
        var initialValue = 0;
        var reducer = (accumulator, item) => {
          return accumulator + item[footItem.key];
        };
        console.log("reducer.decimal=" + reducer);
        // footItem.value = tableData.reduce(reducer, initialValue).toFixed(2);
        if (this.isJsonObjectExist(footItem, "decimals")) {
          footItem.value = Number(
            tableData.reduce(reducer, initialValue)
          ).toLocaleString("it-IT", {
            minimumFractionDigits: footItem.decimals,
          });
        } else {
          footItem.value = tableData.reduce(reducer, initialValue);
        }
        return total;
      }, {});
    },

    getFormatedDecimal(data) {
      return Number(data.value).toLocaleString("it-IT", {
        minimumFractionDigits: data.field.decimals,
      });
    },

    addNewModal() {
      this.isShowDialog = true;
      this.addNew = true;
      this.fieldsData = JSON.parse(
        JSON.stringify(this.columnsToAddDefaultValue)
      );
      this.fieldsToEdit = JSON.parse(JSON.stringify(this.columnsToAdd));
    },

    /** We are displaying the  */

    editRow(data, isview) {
      this.isViewCase = isview;
      this.addNew = false;
      this.isShowDialog = true;
      this.fieldsToEdit = JSON.parse(JSON.stringify(this.columnsToEdit));
      this.realFieldsData = this.getFormatedFieldData(data.item);
      this.fieldsData = JSON.parse(
        JSON.stringify(this.getFormatedFieldData(data.item))
      );
    },

    handDynamic(row, action) {
      switch (action.method) {
        case "PUT":
          // this.isEdit = true;
          this.editRow(row, false);
          break;
        case "GET":
          this.isShow = true;
          this.editRow(row, true);
          break;
        case "DELETE":
          this.isDelete = true;
          this.handleDelete(row);
          break;
        case "view":
              window.open(ApiManger.getCompleteUrl(action.url), "_blank");
          break;

        default:
          break;
      }

      console.log(JSON.stringify(row));
     // console.log(JSON.stringify(action));
    },

    getFormatedFieldData(data) {
      return data;
    },

    resetModal() {
      this.isViewCase = false;
      this.addNew = false;
      this.fieldsData = {};
    },
    handleOk(bvModalEvt) {
      this.isViewCase = false;
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      return valid;
    },
    handleSubmit() {
      var requestMethod = "put";
      if (this.addNew) {
        requestMethod = "post";
      }

      if (!this.isDeleteItem) {
        if (this.checkFormValidity() == false) return;
      } else {
        requestMethod = "delete";
      }

      var vm = this;

      ApiManger.getHome(this.endpoint, requestMethod, this.fieldsData).then(
        (res) => {
          if (res.errorCode == 0) {
            this.isLoading = true;
            this.isBusy = true;
            vm.getUserData(vm.endpoint);
            this.fieldsData = {};
          } else {
            this.message = res;
            this.fieldsData = {};
            this.$emit("status-action", this.message);
          }
        }
      );
      this.$nextTick(() => {
        this.$bvModal.hide("edit-modal");
      });
    },

    onFiltered(filteredItems) {
      // *Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      //console.log("onFiltered");

      //this.updateTotal(this.footerData, this.items);
      this.updateTotal(this.footerData, filteredItems);
    },
    onFilterChange(e) {
      if (e.isDynamic) {
        //this.backendFilters=[];
        this.frontendFilters = [];
        this.getUserData(Auth.getEndPoint().endpoint, e.fieldData);
      } else {
        this.items = this.filterPlainArray(this.allItems, e.fieldData);
        this.onFiltered(this.items);
      }
    },

    // ignores case-sensitive
    // getValue = value => (typeof value === 'string' ? value.toUpperCase() : value),

    /**
     * Filters an array of objects (one level-depth) with multiple criteria.
     *
     * @param  {Array}  array: the array to filter
     * @param  {Object} filters: an object with the filter criteria
     * @return {Array}
     */
    filterPlainArray(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter((item) => {
        // validates all filter criteria
        return filterKeys.every((key) => {
          // ignores an empty filter
          if (filters[key] == null) return true;

          // if (!filters[key].length) return true;
          return filters[key] === item[key];
          //return filters[key].find(filter => filter === item[key]);
        });
      });
    },

    handleDelete(row) {
      this.isDeleteItem = true;
      this.isInfoDialog = true;
      this.message = "¿Está seguro que quiere borrar?";
      this.fieldsData.id = row.item.id;
    },
  },
};
</script>



